export default __webpack_public_path__ + "static/media/icon-stats.c9c54e7e.svg";